import { Link } from 'react-router-dom'
import stackedLogo from '../../Assets/landing/stacked-logo.png'
import stars from '../../Assets/landing/stars.png'
import fb from '../../Assets/landing/fb.png'
import insta from '../../Assets/landing/insta.png'
import msg from '../../Assets/landing/message.png'
import apple from '../../Assets/landing/apple.png'
import android from '../../Assets/landing/google.png'
import { trackEvent } from '../../Analytics/trackEvent'
import { APP_STORE_URL, PLAY_STORE_URL } from './StoreBadges'

/** Shared marketing footer with sitemap links, social and store badges. */
export default function MarketingFooter({ onSupportClick }) {
    return (
        <footer className="app-footer">
            <div className="app-footer-inner">
                <div className="app-footer-left">
                    <img
                        src={stackedLogo}
                        alt="First Dance stacked logo"
                        className="app-footer-logo"
                    />
                    <img src={stars} alt="" className="app-footer-logo-star" />
                </div>
                <div className="app-footer-right">
                    <div className="app-footer-right-inner">
                        <div className="app-footer-social">
                            <a href="https://www.facebook.com/firstdanceapp" target="_blank" rel="noreferrer">
                                <img
                                    className="app-footer-social-icon"
                                    src={fb}
                                    alt="First Dance wedding planning app on Facebook"
                                />
                            </a>
                            <a href="https://www.instagram.com/firstdanceapp/" target="_blank" rel="noreferrer">
                                <img
                                    className="app-footer-social-icon"
                                    src={insta}
                                    alt="First Dance wedding planner app on Instagram"
                                />
                            </a>
                            {onSupportClick && (
                                <img
                                    className="app-footer-social-icon app-footer-social-icon-clickable"
                                    src={msg}
                                    alt="First Dance wedding planning app help"
                                    onClick={onSupportClick}
                                />
                            )}
                        </div>

                        <div className="app-footer-store">
                            <a
                                href={APP_STORE_URL}
                                target="_blank"
                                rel="noreferrer"
                                onClick={() => trackEvent('app_store_click', { platform: 'ios' })}
                            >
                                <img
                                    className="app-footer-app-icon"
                                    style={{ marginRight: 10 }}
                                    src={apple}
                                    alt="First Dance wedding planner app UK | iOS App Store"
                                />
                            </a>
                            <a
                                href={PLAY_STORE_URL}
                                target="_blank"
                                rel="noreferrer"
                                onClick={() => trackEvent('app_store_click', { platform: 'android' })}
                            >
                                <img
                                    className="app-footer-app-icon"
                                    src={android}
                                    alt="First Dance wedding planner app UK | Google Play Store"
                                />
                            </a>
                        </div>

                        <nav className="app-footer-links">
                            <Link className="app-footer-link" to="/features">
                                Features
                            </Link>
                            <Link className="app-footer-link" to="/pricing">
                                Pricing
                            </Link>
                            <Link className="app-footer-link" to="/blog">
                                Wedding Planning Tips
                            </Link>
                            <Link className="app-footer-link" to="/terms">
                                Terms &amp; Conditions
                            </Link>
                            <Link className="app-footer-link" to="/privacy-policy">
                                Privacy Policy
                            </Link>
                        </nav>

                        <p className="app-footer-copy">
                            &copy; {new Date().getFullYear()} First Dance &mdash; The fun way to plan your
                            wedding day
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    )
}
